<template>
  <Modal
    ref="uploadImagesModal"
    :title="'Import Dataset'"
    width="600px"
  >
    <template #modal-main>
      <div class="upload-images scrollbar">
        <div class="form">
          <DefaultImportScriptForm
            ref="defaultImportScriptForm"
            :datasetID="datasetID"
            :annotationSets="annotationSets"
            @upload-started="closeModal"
            @upload-complete="handleUploadComplete"
            @upload-error="(params) => $emit('upload-error', params)"
            @confirm-duplicate-upload="(params) => $emit('confirm-duplicate-upload',params)"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import DefaultImportScriptForm from '@/components/DatasetComponent/ImportForms/DefaultImportScriptForm.vue';

export default {
  name: 'UploadImagesModal',
  components: {
    Modal,
    DefaultImportScriptForm,
  },
  props: {
    datasetID: {
      type: Number,
      default: null,
    },
    annotationSets: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['refresh', 'upload-error', 'confirm-duplicate-upload'],
  methods: {
    handleUploadComplete() {
      this.closeModal();
      this.$emit('refresh');
    },
    showModal() {
      this.$refs.uploadImagesModal.showModal();
    },
    closeModal() {
      this.$refs.uploadImagesModal.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>

.upload-images {
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  overflow: auto;
}

@media (min-width: $breakpoint-sm) {
  .upload-images {
    width: 600px;
  }
}

</style>
